import React, { useState, useEffect } from 'react';
import { parse } from 'devaluex';
import { openDB } from 'idb';
import './MapImporter.css';

const EAGLER_DB_NAME = '_net_lax1dude_eaglercraft_v1_8_internal_PlatformFilesystem_1_12_2_';
const MPC_LOADED_KEY = 'mpc_map_loaded';
const MPC_IDB_FILE = '/mpc/mpc.idb';

const EAGLER_LOCALSTORAGE_PRESETS = {
  '_eaglercraft_1.12.g': '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',
  '_eaglercraft_1.12.p': 'H4sIAAAAAAAA/+NiYOBkYE1OLEgtZgABZgaugqLU4tQSZ6AQVCC5tLgkPxck8B8IgMqLszPzIMo5GDhKi1OL8hJzUxnYvVPzqjLTKuFGBAOVoRgBEgAZwQAAfWBAFHYAAAA=',
};
const EAGLER_STORE_NAME = 'filesystem';

async function checkIDBExists() {
  return new Promise((resolve) => {
    const req = indexedDB.open(EAGLER_DB_NAME);
    req.onsuccess = (e) => {
      const db = e.target.result;
      const exists = db.objectStoreNames.length > 0;
      db.close();
      resolve(exists);
    };
    req.onerror = () => resolve(false);
    req.onupgradeneeded = (e) => {
      e.target.transaction.abort();
      resolve(false);
    };
  });
}

async function initEaglerDB() {
  const db = await openDB(EAGLER_DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(EAGLER_STORE_NAME)) {
        db.createObjectStore(EAGLER_STORE_NAME, { keyPath: ['path'] });
      }
    },
  });
  db.close();
}

async function importIDB(blob, onProgress) {
  const stream = blob.stream().pipeThrough(new TextDecoderStream());
  const lineStream = stream.pipeThrough(new TransformStream({
    start() { this._buf = ''; },
    transform(chunk, controller) {
      this._buf += chunk;
      const lines = this._buf.split('\n');
      for (let i = 0; i < lines.length - 1; i++) {
        if (lines[i].trim()) controller.enqueue(lines[i]);
      }
      this._buf = lines[lines.length - 1];
    },
    flush(controller) {
      if (this._buf.trim()) controller.enqueue(this._buf);
    },
  }));

  const reader = lineStream.getReader();

  const metaChunk = await reader.read();
  if (!metaChunk.value) throw new Error('Data error: missing header line');
  const meta = parse(metaChunk.value);

  const db = await openDB(meta.name, meta.version);
  try {
    if (db.objectStoreNames.length === 0) throw new Error('Empty database');
    const storeNames = Array.from(db.objectStoreNames);
    const total = meta.stores.reduce((acc, it) => acc + it.count, 0);
    let i = 0;
    while (true) {
      const chunk = await reader.read();
      if (chunk.done) break;
      const item = parse(chunk.value);
      if (!storeNames.includes(item.storeName)) {
        throw new Error(`Store ${item.storeName} not found`);
      }
      const tx = db.transaction(item.storeName, 'readwrite');
      const store = tx.objectStore(item.storeName);
      if (store.keyPath === null) {
        await store.put(item.value, item.key);
      } else {
        await store.put(item.value);
      }
      i++;
      onProgress && onProgress(i, total);
    }
  } finally {
    db.close();
  }
}

const MapImporter = ({ gameId, onComplete, showReinstall }) => {
  const [phase, setPhase] = useState('checking');
  const [statusText, setStatusText] = useState('');
  const [progress, setProgress] = useState(0);
  const [, setRecordsProcessed] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [isReinstall, setIsReinstall] = useState(false);

  const runImport = async () => {
    try {
      setPhase('loading');
      setStatusText('正在下载枫城');
      setProgress(0);
      setRecordsProcessed(0);
      setTotalRecords(0);

      const response = await fetch(MPC_IDB_FILE);
      if (!response.ok) throw new Error(`下载失败 (${response.status})`);

      const contentLength = response.headers.get('Content-Length');
      const total = contentLength ? parseInt(contentLength, 10) : 0;
      let received = 0;
      const reader = response.body.getReader();
      const chunks = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        if (total > 0) {
          setProgress(Math.round((received / total) * 100));
          setRecordsProcessed(received);
          setTotalRecords(total);
        }
      }
      const blob = new Blob(chunks);

      setStatusText('正在导入枫城');

      await importIDB(blob, (current, total) => {
        setRecordsProcessed(current);
        setTotalRecords(total);
        setProgress(total > 0 ? Math.round((current / total) * 100) : 0);
      });

      localStorage.setItem(MPC_LOADED_KEY, '1');
      setPhase('done');
      if (isReinstall) {
        setTimeout(() => window.location.reload(), 400);
      } else {
        setTimeout(() => onComplete && onComplete(), 400);
      }
    } catch (err) {
      console.error('MapImporter auto-import error:', err);
      setError(err.message);
      setPhase('error');
    }
  };

  useEffect(() => {
    if (parseInt(gameId) !== 939) {
      onComplete && onComplete();
      return;
    }

    const run = async () => {
      try {
        const alreadyLoaded = localStorage.getItem(MPC_LOADED_KEY);
        if (alreadyLoaded) {
          setPhase('idle');
          onComplete && onComplete();
          return;
        }

        const idbExists = await checkIDBExists();
        if (idbExists) {
          setPhase('confirm');
          return;
        }

        setPhase('loading');
        setStatusText('正在下载枫城');

        for (const [key, value] of Object.entries(EAGLER_LOCALSTORAGE_PRESETS)) {
          localStorage.setItem(key, value);
        }
        await initEaglerDB();

        await runImport();
      } catch (err) {
        console.error('MapImporter init error:', err);
        setError(err.message);
        setPhase('error');
      }
    };

    run();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameId, retryCount]);

  if (parseInt(gameId) !== 939) return null;

  if (phase === 'done') return null;

  if (showReinstall && phase === 'idle') {
    return (
      <button
        className="mpc-reinstall-btn"
        onClick={() => { setIsReinstall(true); setPhase('confirm'); }}
      >
        重新安装枫城
      </button>
    );
  }

  if (!showReinstall && phase === 'idle') return null;

  return (
    <div className="mpc-overlay">
      <div className="mpc-overlay-inner">
        {phase === 'confirm' && (
          <div className="mpc-confirm">
            <p className="mpc-confirm-text">
              导入枫城将会覆盖您浏览器上的我的世界1.12.2存档，确定继续吗
            </p>
            <div className="mpc-confirm-buttons">
              <button
                className="mpc-btn mpc-btn-cancel"
                onClick={() => { if (isReinstall) { setIsReinstall(false); setPhase('idle'); } else { onComplete && onComplete(); } }}
              >
                取消
              </button>
              <button
                className="mpc-btn mpc-btn-confirm"
                onClick={() => { runImport(); }}
              >
                确定
              </button>
            </div>
          </div>
        )}

        {phase === 'checking' && (
          <div className="mpc-status">
            <div className="mpc-spinner" />
          </div>
        )}

        {phase === 'loading' && (
          <div className="mpc-status">
            <span className="mpc-status-text">{statusText}</span>
            <div className="mpc-progress-wrap">
              <div className="mpc-progress-bar">
                <div className="mpc-progress-fill" style={{ width: `${progress}%` }} />
              </div>
              {totalRecords > 0 && (
                <span className="mpc-progress-label">{progress}%</span>
              )}
            </div>
          </div>
        )}

        {phase === 'error' && (
          <div className="mpc-error">
            <p>导入失败: {error}</p>
            <button className="mpc-btn mpc-btn-confirm" onClick={() => { setError(null); setPhase('checking'); setRetryCount(c => c + 1); }}>
              重试
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapImporter;
